import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabaseClient } from "../../../lib/supabase";

import useInvalidateDiaries from "../../diaries/features/edit/api/invalidateDiaries";

interface SharedAttributesUpsert {
	shared_attribute_id: string;
	start_date?: string | null;
	end_date?: string | null;
	reference_date?: string | null;
	hospital_number?: string | null;
	contact_id?: string | null;
}

export async function upsertSharedAttributes(
	attributes: SharedAttributesUpsert,
) {
	const { data, error } = await supabaseClient
		.from("shared_attributes")
		.upsert(attributes)
		.select("*")
		.single();

	if (error) throw error;
	return data;
}

export const useUpsertSharedAttributes = () => {
	const invalidateDiaries = useInvalidateDiaries();

	return useMutation({
		mutationKey: ["upsert-shared-attributes"],
		mutationFn: (attributes: SharedAttributesUpsert) =>
			upsertSharedAttributes(attributes),
		onError: () => {
			toast.error("Error upserting shared attributes");
		},
		onSuccess: () => {
			toast.success("Shared attributes upserted");
		},
		onSettled: () => {
			invalidateDiaries();
		},
	});
};
